import { Moment } from 'moment';
import { AvisoBaja, SinTelefono, Tareas as Tarea, TipoDeImportacion } from '../../enums/leave-import.enums';
import { CheckBoxValue } from '../../types/checkbox.type';

export class LeaveImportTemplate {

    constructor(
        public parameters: Parameters,
        public leaveTypes: TipoDeBaja[],
        public excelColumns: ExcelColumn[],
    ) { }

}

export class Parameters {
    public nombre: string;
    public importacionId: number;

    constructor(
        public primeraFila: number,
        public columnaClave: number,
        public hojas: number,
        public tipoImportacion: TipoDeImportacion,
        public avisosBaja: AvisoBaja,
        public tarea: Tarea,
        public criterioId: number,
        public sinTelefono: SinTelefono,
        public actualizarTrabajador: CheckBoxValue,
        public actualizarReferencia: CheckBoxValue,
        public actualizarIdentificadores: CheckBoxValue,
        public actualizarEmpresa: CheckBoxValue,
        public actualizarMobilidad: CheckBoxValue,
        public actualizarTipoBaja: CheckBoxValue,

        public diasPv: number,
    ) { }
}

export class TipoDeBaja {
    constructor(
        public tipoBaja: string,
        public excel: string,
    ) { }
}

export class ExcelColumn {
    constructor(
        public columna: number,
        public campo: string,
    ) { }
}